// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/updateLog.css
// module id = 2660
// module chunks = 2